module.exports = __webpack_public_path__ + "img/logo.bcc32540.jpg";